import Main from '@/components/main';

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  title: { String|Number|Function }
 *         显示在侧边栏、面包屑和标签栏的文字
 *         使用'{{ 多语言字段 }}'形式结合多语言使用，例子看多语言的路由配置;
 *         可以传入一个回调函数，参数是当前路由对象，例子看动态路由和带参路由
 *  hideInBread: (false) 设为true后此级路由将不会出现在面包屑中，示例看QQ群路由配置
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面在切换标签后不会缓存，如果需要缓存，无需设置这个字段，而且需要设置页面组件name属性和路由配置的name一致
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */
export default [
  {
    path: '/',
    redirect: '/',
    component: Main,
    meta: {
      hideInBread: true,
      title: '首页',
    },
    children: [
      {
        path: '/home',
        name: 'home',
        meta: {
          hideInBread: true,

          icon: '_screen',
          title: '首页',
        },
        component: () => import('@/view/home/home'),
      },
      {
        path: '/platform/gradeExportConfig',
        name: 'gradeExportConfig',
        meta: {
          icon: '_setting',
          title: '成绩导出规则',
        },
        component: () => import('@/view/platform/gradeExportConfig/index.vue'),
      },
      {
        path: '/archive/main',
        name: 'archiveMain',
        meta: {
          icon: '_folder',
          title: '电子档案库',
        },
        component: () => import('@/view/archive/mainForm.vue'),
      },
      {
        path: '/archive/manual',
        name: 'archiveManual',
        meta: {
          hideInMenu: true,
          title: '手动补档',
        },
        component: () => import('@/view/archive/manual.vue'),
      },
      {
        path: '/publicizeMgnt/philosophy/mainForm',
        name: 'lectureForumApply',
        meta: {
          icon: '_setting',
          title: '讲座论坛申请',
        },
        component: () => import('@/view/publicizeMgnt/philosophy/mainForm.vue'),
      },
      {
        path: '/publicizeMgnt/philosophy/printPage',
        name: 'lectureForumPrint',
        meta: {
          hideInMenu: true,
          title: '讲座论坛申请表打印',
        },
        component: () =>
          import('@/view/publicizeMgnt/philosophy/printPage.vue'),
      },
    ],
  },
  // {
  //   path: '/OASysAnn',
  //   name: 'OASysAnn',
  //   component: Main,
  //   meta: {
  //     icon: '_setting',
  //     title: '公告',
  //     access: ['1001'],
  //   },
  //   children: [
  //     {
  //       path: '/OASysAnnounce',
  //       name: 'OASysAnnounce',
  //       meta: {
  //         title: '公告管理',
  //       },
  //       component: () => import('@/view/system/SysAnnouncement/mainForm.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/dmy',
  //   name: 'dmy',
  //   component: Main,
  //   meta: {
  //     icon: '_setting',
  //     title: '工作管理',
  //     access: ['7001', '7002'],
  //   },
  //   children: [
  //     {
  //       path: '/dmy/dayMant',
  //       name: 'dayMant',
  //       meta: {
  //         title: '日程管理',
  //         access: ['7002'],
  //       },
  //       component: () => import('@/view/dmy/dayMant/mainForm.vue'),
  //     },
  //     {
  //       path: '/dmy/workLogs',
  //       name: 'workLogs',
  //       meta: {
  //         title: '工作日志',
  //         access: ['7002'],
  //       },
  //       component: () => import('@/view/dmy/workLogs/mainForm.vue'),
  //     },
  //     {
  //       path: '/dmy/meetingMgmt/meetVenueApplication',
  //       name: 'meetVenueApplication',
  //       meta: {
  //         title: '会议管理',
  //         access: ['7001'],
  //       },
  //       component: () =>
  //         import('@/view/dmy/meetingMgmt/meetVenueApplication/mainForm.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/reimbursementMgmt',
  //   name: 'reimbursementMgmt',
  //   component: Main,
  //   meta: {
  //     icon: '_setting',
  //     title: '预算管理',
  //     access: ['7002'],
  //   },
  //   children: [
  //     {
  //       path: '/reimbursementMgmt/budgetApplication',
  //       name: 'budgetApplication',
  //       meta: {
  //         title: '预算列表',
  //         access: ['7002'],
  //       },
  //       component: () =>
  //         import('@/view/reimbursementMgmt/budgetApplication/mainForm.vue'),
  //     },
  //     {
  //       path: '/reimbursementMgmt/reimburseMgmt',
  //       name: 'reimburseMgmt',
  //       meta: {
  //         title: '报销管理',
  //         access: ['7002'],
  //       },
  //       component: () =>
  //         import('@/view/reimbursementMgmt/reimburseMgmt/mainForm.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/rfi',
  //   name: 'pms1',
  //   component: Main,
  //   meta: {
  //     icon: '_setting',
  //     title: '请示管理',
  //     access: ['7001', '7002'],
  //   },
  //   children: [
  //     {
  //       path: '/rfi/documentMgmt',
  //       name: 'documentMgmt',
  //       meta: {
  //         title: '公文管理',
  //         access: ['7001'],
  //       },
  //       children: [
  //         {
  //           path: '/rfi/documentMgmt/documentApplication',
  //           name: 'documentApplication',
  //           meta: {
  //             title: '发文申请',
  //             access: ['7002'],
  //           },
  //           component: () =>
  //             import(
  //               '@/view/rfi/documentMgmt/documentApplication/mainForm.vue'
  //             ),
  //         },
  //         {
  //           path: '/rfi/documentMgmt/documentEditApplication',
  //           name: 'documentEditApplication',
  //           meta: {
  //             title: '发文修改申请',
  //             access: ['7001'],
  //           },
  //           component: () =>
  //             import(
  //               '@/view/rfi/documentMgmt/documentEditApplication/mainForm.vue'
  //             ),
  //         },
  //         {
  //           path: '/rfi/documentMgmt/documentApplication/detail',
  //           name: 'documentApplicationDetail',
  //           meta: {
  //             title: '发文详情',
  //           },
  //           component: () =>
  //             import('@/view/rfi/documentMgmt/documentApplication/detail.vue'),
  //         },
  //         {
  //           path: '/rfi/documentMgmt/receivingDocuments/detail',
  //           name: 'receivingDocumentsDetail',
  //           meta: {
  //             title: '收文详情',
  //           },
  //           component: () =>
  //             import('@/view/rfi/documentMgmt/receivingDocuments/detail.vue'),
  //         },
  //         {
  //           path: '/rfi/documentMgmt/receivingDocuments',
  //           name: 'receivingDocuments',
  //           meta: {
  //             title: '外来收文管理',
  //             access: ['7002'],
  //           },
  //           component: () =>
  //             import('@/view/rfi/documentMgmt/receivingDocuments/mainForm.vue'),
  //         },
  //         // {
  //         //   path: '/rfi/documentMgmt/foreignDocuments',
  //         //   name: 'foreignDocuments',
  //         //   meta: {
  //         //     title: '外来收文申请',
  //         //     access: ['7002'],
  //         //   },
  //         //   component: () =>
  //         //     import('@/view/rfi/documentMgmt/foreignDocuments/mainForm.vue'),
  //         // },
  //         // {
  //         //   path: '/rfi/documentMgmt/foreignDocuments/detail',
  //         //   name: 'foreignDocumentsDetail',
  //         //   meta: {
  //         //     title: '外来收文详情',
  //         //   },
  //         //   component: () =>
  //         //     import('@/view/rfi/documentMgmt/foreignDocuments/detail.vue'),
  //         // },
  //         {
  //           path: '/rfi/notificationMgmt',
  //           name: 'notificationMgmt',
  //           meta: {
  //             title: '通知管理',
  //             access: ['7002'],
  //           },
  //           component: () => import('@/view/rfi/notificationMgmt/mainForm.vue'),
  //         },
  //         {
  //           path: '/rfi/documentExchange',
  //           name: 'documentExchange',
  //           meta: {
  //             title: '省电子公文交换系统使用申请',
  //             access: ['7001'],
  //           },
  //           component: () => import('@/view/rfi/documentExchange/mainForm.vue'),
  //         },
  //       ],
  //       component: () => import('@/view/route-view.vue'),
  //     },
  //     {
  //       path: '/rfi/useVehicleMgmt/useVehicle',
  //       name: 'useVehicle',
  //       meta: {
  //         title: '用车申请',
  //         access: ['7002'],
  //       },
  //       component: () =>
  //         import('@/view/rfi/useVehicleMgmt/useVehicle/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/useVehicleMgmt/useVehicle/detail',
  //       name: 'Detail',
  //       meta: {
  //         title: '用车详情',
  //       },
  //       component: () =>
  //         import('@/view/rfi/useVehicleMgmt/useVehicle/detail.vue'),
  //     },
  //     {
  //       path: '/rfi/usealapplication',
  //       name: 'usealapplication',
  //       meta: {
  //         title: '用章管理',
  //         access: ['7002'],
  //       },
  //       component: () => import('@/view/rfi/usealapplication/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/usealapplication/usealDetail',
  //       name: 'usealDetail',
  //       meta: {
  //         title: '用章详情',
  //       },
  //       component: () => import('@/view/rfi/usealapplication/usealDetail.vue'),
  //     },
  //     {
  //       path: '/rfi/usealapplicationNew',
  //       name: 'usealapplicationNew',
  //       meta: {
  //         title: '用章管理通用表单',
  //         access: ['7002'],
  //       },
  //       component: () => import('@/view/rfi/usealapplicationNew/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/usealapplicationNew/usealDetail',
  //       name: 'usealDetailNew',
  //       meta: {
  //         title: '用章详情通用表单',
  //       },
  //       component: () =>
  //         import('@/view/rfi/usealapplicationNew/usealDetail.vue'),
  //     },

  //     {
  //       path: '/rfi/announcementMgmt',
  //       name: 'announcementMgmt',
  //       meta: {
  //         title: '公告管理  ',
  //         access: ['7002'],
  //       },
  //       component: () => import('@/view/rfi/announcementMgmt/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/notificationMgmt/detail',
  //       name: 'notificationMgmtDetail',
  //       meta: {
  //         title: '通知详情',
  //       },
  //       component: () => import('@/view/rfi/notificationMgmt/detail.vue'),
  //     },
  //     {
  //       path: '/rfi/receptionMgmt',
  //       name: 'receptionMgmt',
  //       meta: {
  //         title: '接待管理',
  //         access: ['7002'],
  //       },
  //       component: () => import('@/view/rfi/receptionMgmt/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/receptionMgmt/detail',
  //       name: 'receptionMgmtDetail',
  //       meta: {
  //         title: '接待详情',
  //       },
  //       component: () => import('@/view/rfi/receptionMgmt/detail.vue'),
  //     },
  //     {
  //       path: '/rfi/projectApproval',
  //       name: 'projectApproval',
  //       meta: {
  //         title: '立项管理',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/rfi/projectApproval/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/travelBusiness',
  //       name: 'travelBusiness',
  //       meta: {
  //         title: '差旅申请',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/rfi/travelBusiness/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/projectApproval/detail',
  //       name: 'Detail',
  //       meta: {
  //         title: '立项详情',
  //       },
  //       component: () => import('@/view/rfi/projectApproval/detail.vue'),
  //     },
  //     {
  //       path: '/rfi/printingApplication',
  //       name: 'printingApplication',
  //       meta: {
  //         title: '文印申请',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/rfi/printingApplication/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/visitingRequest',
  //       name: 'visitingRequest',
  //       meta: {
  //         title: '来访请示',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/rfi/visitingRequest/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/onlineApplication',
  //       name: 'onlineApplication',
  //       meta: {
  //         title: '挂网申请',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/rfi/onlineApplication/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/reportApplication',
  //       name: 'reportApplication',
  //       meta: {
  //         title: '报告申请',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/rfi/reportApplication/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/studentLeave',
  //       name: 'studentLeave',
  //       meta: {
  //         title: '学生请假申请',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/rfi/studentLeave/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/printingApplication/detail',
  //       name: 'printingDetail',
  //       meta: {
  //         title: '文印详情',
  //       },
  //       component: () => import('@/view/rfi/printingApplication/detail.vue'),
  //     },
  //     // {
  //     //   path: '/rfi/qinRoom',
  //     //   name: 'qinRoom',
  //     //   meta: {
  //     //     title: '琴房预约记录',
  //     //     access: ['7002'],
  //     //   },
  //     //   component: () => import('@/view/rfi/qinRoom/mainForm.vue'),
  //     // },
  //     {
  //       path: '/pms/restructuringApplication',
  //       name: 'restructuringApplication',
  //       meta: {
  //         title: '采购管理',
  //         access: ['7001'],
  //       },
  //       component: () =>
  //         import('@/view/rfi/restructuringApplication/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/otherRequests',
  //       name: 'otherRequests',
  //       meta: {
  //         title: '请示申请',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/rfi/otherRequests/mainForm.vue'),
  //     },
  //     // {
  //     //   path: '/rfi/otherRequests/printPage',
  //     //   name: 'printPage',
  //     //   meta: {
  //     //     title: '打印',
  //     //   },
  //     //   component: () => import('@/view/rfi/otherRequests/printPage.vue'),
  //     // },
  //     // {
  //     //   path: '/rfi/otherRequests/printPage',
  //     //   name: 'printPage',
  //     //   component: () => import('@/view/rfi/otherRequests/printPage.vue'),
  //     //   meta: {
  //     //     icon: '_setting',
  //     //     title: '打印',
  //     //   },
  //     // },
  //   ],
  // },

  // {
  //   path: '/contract',
  //   name: 'contract',
  //   component: Main,
  //   meta: {
  //     icon: '_setting',
  //     title: '合同管理',
  //     access: ['6001'],
  //   },
  //   children: [
  //     // {
  //     //   path: '/contract/contractHome',
  //     //   name: 'contractHome',
  //     //   meta: {
  //     //     title: '合同首页',
  //     //     access: ['6001'],
  //     //   },
  //     //   component: () => import('@/view/contract/contractHome.vue'),
  //     // },
  //     {
  //       path: '/contract/countersign',
  //       name: 'countersign',
  //       meta: {
  //         title: '合同列表',
  //         access: ['6001'],
  //       },
  //       component: () => import('@/view/contract/countersign/index.vue'),
  //     },
  //     // {
  //     //   path: '/contract/alteration',
  //     //   name: 'alteration',
  //     //   meta: {
  //     //     title: '合同变更',
  //     //     access: ['6002'],
  //     //   },
  //     //   component: () => import('@/view/contract/alteration/index.vue'),
  //     // },
  //   ],
  // },

  // {
  //   path: '/dmy/pms',
  //   name: 'pms',
  //   meta: {
  //     title: '项目管理',
  //     icon: '_setting',
  //     access: ['7002'],
  //   },
  //   children: [
  //     {
  //       path: '/pms/pms/programMgmt',
  //       name: 'programMgmt',
  //       meta: {
  //         title: '项目查看',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/dmy/pms/programMgmt/mainForm.vue'),
  //     },
  //     {
  //       path: '/dmy/pms/programMgmt/programDetails',
  //       name: 'programDetails',
  //       meta: {
  //         title: '项目详情',
  //       },
  //       component: () => import('@/view/dmy/pms/programMgmt/programDetail.vue'),
  //     },
  //     {
  //       path: '/dmy/pms/taskMgmt',
  //       name: 'taskMgmt',
  //       meta: {
  //         title: '任务管理',
  //         access: ['7002'],
  //       },
  //       component: () => import('@/view/dmy/pms/taskMgmt/mainForm.vue'),
  //     },
  //     {
  //       path: '/dmy/pms/taskMgmt/taskMgmtDetails',
  //       name: 'taskDetails',
  //       meta: {
  //         title: '任务详情',
  //       },
  //       component: () => import('@/view/dmy/pms/taskMgmt/taskDetail.vue'),
  //     },
  //   ],
  //   component: Main,
  // },

  // {
  //   path: '/publicizeMgnt',
  //   name: 'publicizeMgnt',
  //   component: Main,
  //   meta: {
  //     icon: '_setting',
  //     title: '宣传管理',
  //     access: ['7001', '7002'],
  //   },
  //   children: [
  //     {
  //       path: '/publicizeMgnt/campusInformation',
  //       name: 'campusInformation ',
  //       meta: {
  //         title: '校园资讯',
  //         access: ['7002'],
  //       },
  //       component: () =>
  //         import('@/view/publicizeMgnt/campusInformation/mainForm.vue'),
  //     },
  //     {
  //       path: '/publicizeMgnt/bannerPromotion',
  //       name: 'bannerPromotion',
  //       meta: {
  //         title: '横幅宣传',
  //         access: ['7002'],
  //       },
  //       component: () =>
  //         import('@/view/publicizeMgnt/bannerPromotion/mainForm.vue'),
  //     },
  //     {
  //       path: '/publicizeMgnt/exhibitionPromotion',
  //       name: 'exhibitionPromotion',
  //       meta: {
  //         title: '展板宣传',
  //         access: ['7002'],
  //       },
  //       component: () =>
  //         import('@/view/publicizeMgnt/exhibitionPromotion/mainForm.vue'),
  //     },
  //     {
  //       path: '/publicizeMgnt/newsReporting',
  //       name: 'newsReporting',
  //       meta: {
  //         title: '新闻报道',
  //         access: ['7002'],
  //       },
  //       component: () =>
  //         import('@/view/publicizeMgnt/newsReporting/mainForm.vue'),
  //     },
  //   ],
  // },

  // {
  //   path: '/kanban',
  //   name: 'kanban',
  //   meta: {
  //     hideInBread: true,

  //     icon: '_screen',
  //     title: '集团看板',
  //   },
  //   component: () => import('@/view/kanban/groupKanban'),
  // },
  // {
  //   path: '/schlloKanban',
  //   name: 'kanban',
  //   meta: {
  //     hideInBread: true,

  //     icon: '_screen',
  //     title: '学校看板看板',
  //   },
  //   component: () => import('@/view/kanban/schlloKanban'),
  // },
  // {
  //   path: '/schlloKanbanf',
  //   name: 'kanban',
  //   meta: {
  //     hideInBread: true,

  //     icon: '_screen',
  //     title: '学校看板看板',
  //   },
  //   component: () => import('@/view/kanban/big'),
  // },

  // {
  //   path: '/rfi/opinionMgmt',
  //   name: 'opinionMgmt',
  //   meta: {
  //     title: '意见管理',
  //     access: ['7001'],
  //     icon: '_setting',
  //   },
  //   children: [
  //     {
  //       path: '/yjx/opinionMgmt/opinionBox',
  //       name: 'opinionBox',
  //       meta: {
  //         title: '意见箱',
  //         access: ['7002'],
  //       },
  //       component: () =>
  //         import('@/view/rfi/opinionMgmt/opinionBox/mainForm.vue'),
  //     },
  //     {
  //       path: '/xzxxx',
  //       name: 'xzxxx',
  //       meta: {
  //         title: '校长信箱',
  //         access: ['7002'],
  //       },
  //       component: () =>
  //         import('@/view/rfi/documentMgmt/receivingDocuments/mainForm.vue'),
  //     },
  //   ],
  //   component: Main,
  // },
  // {
  //   path: '/rfi/repairreportMgmt',
  //   name: 'repairreportMgmt',
  //   meta: {
  //     title: '报修管理',
  //     access: ['7001'],
  //     icon: '_setting',
  //   },
  //   children: [
  //     {
  //       path: '/rfi/repairreportMgmt/repairApplication',
  //       name: 'repairApplication',
  //       meta: {
  //         title: '报修申请',
  //         access: ['7002'],
  //       },
  //       component: () =>
  //         import('@/view/rfi/repairreportMgmt/repairApplication/mainForm.vue'),
  //     },
  //     {
  //       path: '/rfi/repairreportMgmt/repairApplication/detail',
  //       name: 'repairreportMgmtDetail',
  //       meta: {
  //         title: '报修详情',
  //       },
  //       component: () =>
  //         import('@/view/rfi/repairreportMgmt/repairApplication/detail.vue'),
  //     },
  //   ],
  //   component: Main,
  // },
  // {
  //   path: '/students',
  //   name: 'students',
  //   component: Main,
  //   meta: {
  //     icon: '_setting',
  //     title: '学生端信息管理',
  //     access: ['6001'],
  //   },
  //   children: [
  //     {
  //       path: '/students/specialty',
  //       name: 'specialty',
  //       meta: {
  //         title: '专业管理',
  //         access: ['6001'],
  //       },
  //       component: () => import('@/view/students/specialty/index.vue'),
  //     },
  //     {
  //       path: '/students/grade',
  //       name: 'grade',
  //       meta: {
  //         title: '班级管理',
  //         access: ['6001'],
  //       },
  //       component: () => import('@/view/students/grade/index.vue'),
  //     },
  //     {
  //       path: '/students/info',
  //       name: 'info',
  //       meta: {
  //         title: '学生管理',
  //         access: ['6001'],
  //       },
  //       component: () => import('@/view/students/info/index.vue'),
  //     },
  //     {
  //       path: '/students/course',
  //       name: 'course',
  //       meta: {
  //         title: '课程管理',
  //         access: ['6001'],
  //       },
  //       component: () => import('@/view/students/course/index.vue'),
  //     },
  //     {
  //       path: '/students/class-schedule',
  //       name: 'class-schedule',
  //       meta: {
  //         title: '课程表安排',
  //         access: ['6001'],
  //       },
  //       component: () => import('@/view/students/class-schedule/index.vue'),
  //     },
  //     {
  //       path: '/students/cultivate',
  //       name: 'cultivate',
  //       meta: {
  //         title: '人才培养方案',
  //         access: ['6001'],
  //       },
  //       component: () => import('@/view/students/cultivate/index.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/doubleCreationCredit',
  //   name: 'doubleCreationCredit',
  //   component: Main,
  //   meta: {
  //     icon: '_setting',
  //     title: '学分认定',
  //     access: ['6001'],
  //   },
  //   children: [
  //     {
  //       path: '/doubleCreationCredit/batchCreditImport',
  //       name: 'batchCreditImport',
  //       meta: {
  //         title: '学分批量导入',
  //         access: ['6001'],
  //       },
  //       component: () =>
  //         import('@/view/doubleCreationCredit/batchCreditImport/index.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/weapp',
  //   name: 'weapp',
  //   component: Main,
  //   meta: {
  //     icon: '_setting',
  //     title: '小程序管理',
  //     access: ['7001'],
  //   },
  //   children: [
  //     {
  //       path: '/weapp/quickAccess',
  //       name: 'quickAccess',
  //       meta: {
  //         title: '快捷入口',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/weapp/quickAccess/index.vue'),
  //     },
  //   ],
  // },
  // {
  //   path: '/system',
  //   name: 'system',
  //   component: Main,
  //   meta: {
  //     icon: '_setting',
  //     title: '系统管理',
  //     access: ['7001', '7002'],
  //   },
  //   children: [
  //     {
  //       path: '/usercontrol/usercontrol-list',
  //       name: 'UserControl',
  //       meta: {
  //         title: '用户信息',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/system/UserControl.vue'),
  //     },
  //     {
  //       path: '/role/role-list',
  //       name: 'RoleList',
  //       meta: {
  //         title: '角色信息',
  //         access: ['7002'],
  //       },
  //       component: () => import('@/view/system/RoleList.vue'),
  //     },
  //     {
  //       path: '/system/power',
  //       name: 'power',
  //       meta: {
  //         title: '权限管理',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/route-view.vue'),
  //       children: [
  //         {
  //           path: '/system/power/menu',
  //           name: 'menu',
  //           meta: {
  //             title: '菜单管理',
  //             access: ['7002'],
  //           },
  //           component: () => import('@/view/system/power/menu.vue'),
  //         },
  //         {
  //           path: '/system/power/menuCode',
  //           name: 'menuCode',
  //           meta: {
  //             title: '菜单码管理',
  //             access: ['7002'],
  //           },
  //           component: () => import('@/view/system/power/menuCode.vue'),
  //         },
  //       ],
  //     },
  //     {
  //       path: '/system/basicData',
  //       name: 'basicData',
  //       meta: {
  //         title: '主数据管理',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/route-view.vue'),
  //       children: [
  //         {
  //           path: '/rfi/flowMgmt',
  //           name: 'flowMgmt',
  //           meta: {
  //             title: '流程管理',
  //             access: ['7002'],
  //           },
  //           component: () => import('@/view/rfi/flowMgmt/mainForm.vue'),
  //         },
  //         {
  //           path: '/system/organizationalStructure',
  //           name: 'organizationalStructure',
  //           meta: {
  //             title: '组织架构',
  //             access: ['7002'],
  //           },
  //           component: () =>
  //             import('@/view/system/organizationalStructure.vue'),
  //         },
  //         {
  //           path: '/rfi/documentMgmt/printingTemplate',
  //           name: 'printingTemplate',
  //           meta: {
  //             title: '公文模板',
  //             access: ['7001'],
  //           },
  //           component: () =>
  //             import('@/view/rfi/documentMgmt/printingTemplate/mainForm.vue'),
  //         },
  //         {
  //           path: '/rfi/useVehicleMgmt/VehicleMgmt',
  //           name: 'VehicleMgmt',
  //           meta: {
  //             title: '车辆信息',
  //             access: ['7002'],
  //           },
  //           component: () =>
  //             import('@/view/rfi/useVehicleMgmt/VehicleMgmt/mainForm.vue'),
  //         },
  //         {
  //           path: '/rfi/useVehicleMgmt/driverMgmt',
  //           name: 'driverMgmt',
  //           meta: {
  //             title: '司机信息',
  //             access: ['7002'],
  //           },
  //           component: () =>
  //             import('@/view/rfi/useVehicleMgmt/driverMgmt/mainForm.vue'),
  //         },
  //         {
  //           path: '/rfi/officialSealMgmt',
  //           name: 'officialSealMgmt',
  //           meta: {
  //             title: '公章信息管理',
  //             access: ['7002'],
  //           },
  //           component: () => import('@/view/rfi/officialSealMgmt/mainForm.vue'),
  //         },
  //         {
  //           path: '/rfi/repairreportMgmt/maintenanceMeb',
  //           name: 'maintenanceMeb',
  //           meta: {
  //             title: '维修人员',
  //             access: ['7002'],
  //           },
  //           component: () =>
  //             import('@/view/rfi/repairreportMgmt/maintenanceMeb/mainForm.vue'),
  //         },
  //         {
  //           path: '/contract/template',
  //           name: 'template',
  //           meta: {
  //             title: '合同模板',
  //             access: ['6002'],
  //           },
  //           component: () => import('@/view/contract/template/index.vue'),
  //         },
  //         {
  //           path: '/dmy/meetingMgmt/meetVenueInfo',
  //           name: 'meetVenueInfo',
  //           meta: {
  //             title: '会议场所信息管理',
  //             access: ['7001'],
  //           },
  //           component: () =>
  //             import('@/view/dmy/meetingMgmt/meetVenueInfo/mainForm.vue'),
  //         },
  //       ],
  //     },
  //   ],
  // },
  // // {
  // //   path: '/kanbanNew',
  // //   name: 'kanbanNew',
  // //   component: () => import('@/view/kanbanNew/index.vue'),
  // //   meta: {
  // //     icon: '_setting',
  // //     title: '数据中台大屏新的',
  // //     access: ['7001', '7002'],
  // //   },
  // // },
  // {
  //   path: '/dataBoard',
  //   name: 'dataBoard',
  //   component: () => import('@/view/kanban/dataBoard.vue'),
  //   meta: {
  //     icon: '_setting',
  //     title: '集团数据看板',
  //     access: ['7001', '7002'],
  //   },
  // },
  // {
  //   path: '/kanban',
  //   name: 'kanban',
  //   component: () => import('@/view/kanban/groupKanban.vue'),
  //   meta: {
  //     icon: '_setting',
  //     title: '数据中台大屏',
  //     access: ['7001', '7002'],
  //   },
  // },
  // {
  //   path: '/schoolBoard',
  //   name: 'schoolBoard',
  //   component: () => import('@/view/kanban/schoolBoard.vue'),
  //   meta: {
  //     icon: '_setting',
  //     title: '学校数据看板',
  //     access: ['7001', '7002'],
  //   },
  // },
  // {
  //   path: '/rfi/otherRequests/printPage',
  //   name: 'printPage',
  //   component: () => import('@/view/rfi/otherRequests/printPage.vue'),
  //   meta: {
  //     icon: '_setting',
  //     title: '其他打印',
  //   },
  // },
  // {
  //   path: '/rfi/documentMgmt/documentApplication/printPage',
  //   name: 'documentApplicationPrintPage',
  //   component: () =>
  //     import('@/view/rfi/documentMgmt/documentApplication/printPage.vue'),
  //   meta: {
  //     icon: '_setting',
  //     title: '收文打印',
  //   },
  // },
  // {
  //   path: '/rfi/documentMgmt/receivingDocuments/printPage',
  //   name: 'receivingDocumentsPrintPage',
  //   component: () =>
  //     import('@/view/rfi/documentMgmt/receivingDocuments/printPage.vue'),
  //   meta: {
  //     icon: '_setting',
  //     title: '发文打印',
  //   },
  // },
  // {
  //   path: '/rfi/useVehicleMgmt/useVehicle/printPage',
  //   name: 'useVehiclePrintPage',
  //   component: () =>
  //     import('@/view/rfi/useVehicleMgmt/useVehicle/printPage.vue'),
  //   meta: {
  //     icon: '_setting',
  //     title: '用车打印',
  //   },
  // },
  // {
  //   path: '/rfi/usealapplication/printPage',
  //   name: 'usealapplicationPrintPage',
  //   component: () => import('@/view/rfi/usealapplication/printPage.vue'),
  //   meta: {
  //     icon: '_setting',
  //     title: '用章打印',
  //   },
  // },
  // {
  //   path: '/rfi/announcementMgmt/printPage',
  //   name: 'announcementMgmtPrintPage',
  //   component: () => import('@/view/rfi/announcementMgmt/printPage.vue'),
  //   meta: {
  //     icon: '_setting',
  //     title: '公告打印',
  //   },
  // },
  // // {
  // //   path: '/kanban/groupKanban',
  // //   name: 'groupKanban',
  // //   meta: {
  // //     title: '集团数据大屏',
  // //     access: ['7001'],
  // //
  // //   },
  // //   component: () => import('@/view/kanban/groupKanban.vue'),
  // // },
  // // {
  // //   path: '/kanban/kanbanSchool',
  // //   name: 'kanbanSchool',
  // //   meta: {
  // //     title: '湛江科技学院数据大屏',
  // //     access: ['7001'],
  // //
  // //   },
  // //   component: () => import('@/view/kanban/schlloKanban.vue'),
  // // },
  // {
  //   path: '/formCreate',
  //   name: 'formCreate',
  //   meta: {
  //     icon: '_setting',
  //     title: '智慧代码',
  //     access: ['7001'],
  //   },
  //   component: Main,
  //   children: [
  //     {
  //       path: '/formCreate/index',
  //       name: 'formCreateIndex',
  //       meta: {
  //         title: '动态生成',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/formCreate/index.vue'),
  //     },
  //     {
  //       path: '/formCreate/PageOffice',
  //       name: 'PageOffice',
  //       meta: {
  //         title: 'PageOffice',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/formCreate/PageOffice.vue'),
  //     },
  //     {
  //       path: '/formCreate/dotNetCreate',
  //       name: 'dotNetCreate',
  //       meta: {
  //         title: '.NET后端生成',
  //         access: ['7001'],
  //       },
  //       component: () => import('@/view/formCreate/dotNetCreate.vue'),
  //     },
  //   ],
  // },
  { path: '*', redirect: '/404', hidden: true },
  // {
  //   path: '/showDoc',
  //   name: 'doc',
  //   component: () => import('@/view/DocView/DocView.vue'),
  // },
];
